import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";

export default function SuppressionsPage() {
  const [items, setItems] = useState([]);
  const load = () => api.suppressions().then(setItems);
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-heading text-2xl font-medium tracking-tight">Suppressions</h2>
        <p className="text-sm text-zinc-500 mt-0.5">Emails that won't receive future sends — unsubscribed, bounced, or complaint.</p>
      </div>
      <div className="rounded-lg border border-zinc-200 bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="text-xs text-zinc-500 border-b border-zinc-200"><tr>
            <th className="text-left px-3 py-2 font-medium">Email</th>
            <th className="text-left px-3 py-2 font-medium">Reason</th>
            <th className="text-left px-3 py-2 font-medium">Added</th>
            <th className="text-right px-3 py-2"/>
          </tr></thead>
          <tbody>
            {items.map(s => (
              <tr key={s.email} className="border-b border-zinc-100">
                <td className="px-3 py-2 font-mono text-[12.5px]">{s.email}</td>
                <td className="px-3 py-2 capitalize">{s.reason}</td>
                <td className="px-3 py-2 text-xs text-zinc-500">{new Date(s.created_at).toLocaleString()}</td>
                <td className="px-3 py-2 text-right">
                  <button onClick={async () => { const r = await api.removeSuppression(s.email); toast.success(r.contact_reactivated ? "Removed — contact reactivated and will receive emails again" : "Removed from suppressions"); load(); }} className="text-zinc-400 hover:text-rose-700"><Trash size={14}/></button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-sm text-zinc-500">No suppressions</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
